/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from 'react';
import { Row, Col, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import 'react-datepicker/dist/react-datepicker.css';
import SelectWithPagination from 'components/shared/dropdown-with-pagination/SelectWithPagination';
import Pill from 'components/shared/pills/Pill';
import { setSquad } from 'store/customer/customerViewSlice';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import DateRangePicker from './DateRangePicker';
import classes from './EngagementFilters.module.scss';

const EngagementFilters = () => {
  const dispatch = useDispatch();
  const [menuIsOpen, setMenuIsOpen] = useState({
    StakeholderName: false,
    StakeholderType: false,
    Engagement: false,
    Squad: false,
    Brand: false,
    Indication: false,
    GNE_User_Name: false,
    GENE_User_Role: false,
    EngagementEcosystem: false,
  });

  const engagementFilters = useSelector(
    (state) => state?.CustomerView?.engagementFilters
  );
  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );
  const selectedStartDate = useSelector(
    (state) => state?.CustomerView?.engagementFilters?.startDate?.selectedValue
  );

  const selectedEndDate = useSelector(
    (state) => state?.CustomerView?.engagementFilters?.endDate?.selectedValue
  );
  const squadSelectedValue = engagementFilters?.Squad?.selectedValue;

  const handleSquadClose = (value) => {
    const filteredData = squadSelectedValue.filter((item) => item !== value);

    dispatch(
      setSquad({ ...engagementFilters['Squad'], selectedValue: filteredData })
    );
  };
  const onMenuOpen = useCallback((filterName, value) => {
    let menuIsOpenLocal = menuIsOpen;
    if (filterName !== '' && value) {
      menuIsOpenLocal = Object.keys(menuIsOpen).reduce((acc, key) => {
        return { ...acc, [key]: filterName === key };
      }, {});
    } else if ((filterName !== '' && !value) || filterName === '') {
      menuIsOpenLocal = Object.keys(menuIsOpen).reduce((acc, key) => {
        return { ...acc, [key]: false };
      }, {});
    }
    setMenuIsOpen({ ...menuIsOpenLocal });
  }, []);

  const EcosystemTooltip = (
    <Tooltip className='gne-tooltip'>
      Please note that applying the ecosystem filter may <br />
      exclude certain engagements, like house emails <br />
      and medical inquiries, as they currently can’t be
      <br />
      tracked at the ecosystem level.
    </Tooltip>
  );

  return (
    <>
      <Row className='mb-3 mt-3'>
        <DateRangePicker />
        <Col className={classes['filter-container']}>
          <label className='title__x-small d-block'>Stakeholder Name</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={engagementFilters}
            fieldName='StakeholderName'
            isMulti={true}
            isTitleCase={true}
            cacheUniqs={[selectedCustomer, selectedStartDate, selectedEndDate]}
          />
        </Col>
        <Col className={classes['filter-container']}>
          <label className='title__x-small d-block'>Stakeholder Type</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={engagementFilters}
            fieldName='StakeholderType'
            isMulti={true}
            cacheUniqs={[selectedCustomer, selectedStartDate, selectedEndDate]}
          />
        </Col>
        <Col className={classes['filter-container']}>
          <label className='title__x-small d-block'>Engagements</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={engagementFilters}
            fieldName='Engagement'
            isMulti={true}
            cacheUniqs={[selectedCustomer, selectedStartDate, selectedEndDate]}
          />
        </Col>
        <Col className={classes['filter-container']}>
          <label className='title__x-small d-block'>Squad</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={engagementFilters}
            fieldName='Squad'
            isMulti={true}
            cacheUniqs={[selectedCustomer, selectedStartDate, selectedEndDate]}
          />
        </Col>
      </Row>
      <Row>
        <Col className={classes['filter-container']}>
          <label className='title__x-small d-block'>Brand</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={engagementFilters}
            fieldName='Brand'
            isMulti={true}
            cacheUniqs={[selectedCustomer, selectedStartDate, selectedEndDate]}
          />
        </Col>
        <Col className={classes['filter-container']}>
          <label className='title__x-small d-block'>Indication</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={engagementFilters}
            fieldName='Indication'
            isMulti={true}
            cacheUniqs={[selectedCustomer, selectedStartDate, selectedEndDate]}
          />
        </Col>
        <Col className={classes['filter-container']}>
          <label className='title__x-small d-block'>User Name</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={engagementFilters}
            fieldName='GNE_User_Name'
            isMulti={true}
            cacheUniqs={[selectedCustomer, selectedStartDate, selectedEndDate]}
          />
        </Col>
        <Col className={classes['filter-container']}>
          <label className='title__x-small d-block'>User Role</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={engagementFilters}
            fieldName='GENE_User_Role'
            isMulti={true}
            cacheUniqs={[selectedCustomer, selectedStartDate, selectedEndDate]}
          />
        </Col>
        <Col className={classes['filter-container']}>
          <div className='d-flex align-items-center'>
            <label className='title__x-small'>Ecosystem</label>
            <OverlayTrigger overlay={EcosystemTooltip}>
              <i className='icon icon__info__gray ms-2 mb-2' />
            </OverlayTrigger>
          </div>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={engagementFilters}
            fieldName='EngagementEcosystem'
            isMulti={true}
            cacheUniqs={[selectedCustomer, selectedStartDate, selectedEndDate]}
          />
        </Col>
        <Col></Col>
      </Row>
      <div className='gne-pill'>
        {squadSelectedValue?.map((item) => (
          <Pill
            value={item}
            handleClose={handleSquadClose}
            key={uuidv4()}
          />
        ))}
      </div>

      {/* legend */}
      <Row>
        <Col className='mb-2'>
          <div className={classes.legend}>
            <span className='me-2'>
              <i className='circle-blue mt-4' />
              Internal
            </span>
            <span>
              <i className='circle-green' />
              External
            </span>
          </div>
        </Col>
      </Row>
      <div className='divider-horizontal'></div>
    </>
  );
};

export default EngagementFilters;
